<h3 class="text-primary mb-[5px] border" i18n="@@fees_charges_configuration">
  Fees/Charges Configuration
</h3>
<div class="border-[1px] border-[#D5D5D5] rounded-[10px] p-[12px]">
  <div class="fee-charge-section bg-[#F2F2F2] rounded-[10px] p-[15px]">
    <div class="flex items-center">
      <app-button-icon-ui
        [isDisabled]="isDisabled"
        [buttonType]="'button'"
        [icon]="'add'"
        [name]="'Add Fee/Charge'"
        i18n-name="@@add_fee_charge"
        [value]="'add'"
        [classNames]="
          'text-secondary rounded-[5px] bg-white hover:bg-secondary hover:text-white
          border-[#D5D5D5] h-[30px] px-[10px] mb-8'
        "
        (clickEmit)="addRow()"
      >
      </app-button-icon-ui>
    </div>

    <!-- Header row -->
    <div *ngIf="rows.length > 0" class="flex mb-[7px]">
      <div class="w-[10px]"></div>
      <div
        class="w-[20%] border-b border-[#979797] pb-2 text-center font-semibold text-sm ml-[15px]"
      >
        <mat-label>{{ nameHeader }}</mat-label>
      </div>
      <div
        class="w-[9%] border-b border-[#979797] pb-2 text-center font-semibold text-sm ml-[14px]"
      >
        <mat-label i18n="@@value">Value</mat-label>
      </div>
      <div
        class="w-[13%] border-b border-[#979797] pb-2 text-center font-semibold text-sm ml-[15px]"
      >
        <mat-label i18n="@@minimum_value">Minimum Value</mat-label>
      </div>
      <div
        class="w-[13%] border-b border-[#979797] pb-2 text-center font-semibold text-sm ml-[16px]"
      >
        <mat-label i18n="@@maximum_value">Maximum Value</mat-label>
      </div>
      <div
        class="font-semibold border-b border-[#979797] pb-2 text-sm flex-1 text-center ml-[19px]"
      >
        <mat-label i18n="@@event">Event</mat-label>
      </div>
      <div class="w-[30px] ml-[30px]" aria-hidden="true"></div>
    </div>

    <!-- Rows -->
    <div cdkDropList (cdkDropListDropped)="drop($event)" class="w-full">
      <div
        *ngFor="let row of rows; let i = index; trackBy: trackByRow"
        cdkDrag
        cdkDragPreviewContainer="parent"
        class="flex flex-col gap-[2px] mb-[8px]"
      >
        <div *cdkDragPlaceholder class="fee-row-placeholder"></div>
        <div class="flex items-start">
          <!-- Drag handle -->
          <div cdkDragHandle class="w-[10px] mt-[8px] cursor-grab">
            <img src="assets/icons/drag-drop-icon.svg" alt="" />
          </div>

          <!-- Fee/Charge dropdown -->
          <div class="flex flex-col w-[20%] ml-[15px]">
            <mat-form-field
              appearance="outline"
              class="short_height w-full"
              [ngClass]="{
                'field-error': hasError(i, 'chargeId'),
                'highlight-mat-input': row | feeFieldChanged: oldRows[i] : 'chargeId'
              }"
            >
              <mat-select
                [(ngModel)]="row.chargeId"
                [disabled]="isDisabled"
                (selectionChange)="onChargeSelect(row, $event.value)"
              >
                <mat-option *ngFor="let charge of charges" [value]="charge.id">
                  {{ charge.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <small
              *ngIf="row | feeFieldChanged: oldRows[i] : 'chargeId'"
              class="flex justify-end px-2 opacity-80"
            >
              {{ oldRows[i] | feeOldChargeName: charges }}
            </small>
          </div>

          <!-- Value (loaded from charge, display-only) -->
          <div class="flex flex-col w-[9%] ml-[14px]">
            <mat-form-field
              appearance="outline"
              class="short_height w-full"
              [ngClass]="{ 'highlight-mat-input': row | feeFieldChanged: oldRows[i] : 'value' }"
            >
              <input matInput readonly [disabled]="isDisabled" [ngModel]="row | feeValueDisplay" />
            </mat-form-field>
            <small
              *ngIf="row | feeFieldChanged: oldRows[i] : 'value'"
              class="flex justify-end px-2 opacity-80"
            >
              {{ oldRows[i] | feeValueDisplay }}
            </small>
          </div>

          <!-- Minimum Value -->
          <div class="flex flex-col w-[13%] ml-[15px]">
            <mat-form-field
              appearance="outline"
              class="short_height w-full"
              [ngClass]="{
                'field-error': hasError(i, 'minMax'),
                'highlight-mat-input': row | feeFieldChanged: oldRows[i] : 'minimumValue'
              }"
            >
              <input
                appCurrency
                matInput
                [(ngModel)]="row.minimumValue"
                [disabled]="isDisabled || row.chargeType === 'FLAT'"
                (blur)="updateErrors()"
              />
            </mat-form-field>
            <small
              *ngIf="row | feeFieldChanged: oldRows[i] : 'minimumValue'"
              class="flex justify-end px-2 opacity-80"
              >{{ oldRows[i]?.minimumValue }}</small
            >
          </div>

          <!-- Maximum Value -->
          <div class="flex flex-col w-[13%] ml-[16px]">
            <mat-form-field
              appearance="outline"
              class="short_height w-full"
              [ngClass]="{
                'field-error': hasError(i, 'minMax'),
                'highlight-mat-input': row | feeFieldChanged: oldRows[i] : 'maximumValue'
              }"
            >
              <input
                appCurrency
                matInput
                [(ngModel)]="row.maximumValue"
                [disabled]="isDisabled || row.chargeType === 'FLAT'"
                (blur)="updateErrors()"
              />
            </mat-form-field>
            <small
              *ngIf="row | feeFieldChanged: oldRows[i] : 'maximumValue'"
              class="flex justify-end px-2 opacity-80"
              >{{ oldRows[i]?.maximumValue }}</small
            >
          </div>

          <!-- Event type + inline sub-value -->
          <div class="flex flex-col flex-1 min-w-0 ml-[19px]">
            <div
              class="combined-event-field flex items-center rounded-[4px] bg-[#FCFCFC] h-[30px] min-w-0"
              [ngClass]="{
                'event-error': hasError(i, 'eventType'),
                'opacity-80': isDisabled,
                'highlight-mat-input': row | feeEventScheduleChanged: oldRows[i]
              }"
            >
              <!-- Event type select -->
              <mat-form-field
                appearance="outline"
                class="short_height combined-inner"
                [ngClass]="
                  row.eventType === 'QUARTERLY' || row.eventType === 'SEMI_ANNUALLY'
                    ? 'shrink-0'
                    : 'flex-1 min-w-0'
                "
                [style.flex]="
                  row.eventType === 'QUARTERLY'
                    ? '0 0 85px'
                    : row.eventType === 'SEMI_ANNUALLY'
                      ? '0 0 105px'
                      : null
                "
              >
                <mat-select
                  [(ngModel)]="row.eventType"
                  [disabled]="isDisabled"
                  (selectionChange)="onEventTypeChange(row)"
                >
                  <mat-option *ngFor="let eventType of cachedEventTypes" [value]="eventType.value">
                    {{ eventType.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Daily → time -->
              <ng-container *ngIf="row.eventType === 'DAILY'">
                <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                <mat-form-field
                  appearance="outline"
                  class="short_height flex-1 min-w-0 combined-inner"
                  [ngClass]="{ 'field-error': hasError(i, 'eventSubValue') }"
                >
                  <mat-select
                    [(ngModel)]="row.eventSubValue"
                    [disabled]="isDisabled"
                    (ngModelChange)="emitRows()"
                  >
                    <mat-option *ngFor="let timeOption of timeOptions" [value]="timeOption">{{
                      timeOption
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <!-- Weekly → day -->
              <ng-container *ngIf="row.eventType === 'WEEKLY'">
                <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                <mat-form-field
                  appearance="outline"
                  class="short_height flex-1 min-w-0 combined-inner"
                  [ngClass]="{ 'field-error': hasError(i, 'eventSubValue') }"
                >
                  <mat-select
                    [(ngModel)]="row.eventSubValue"
                    [disabled]="isDisabled"
                    (ngModelChange)="emitRows()"
                  >
                    <mat-option *ngFor="let day of weekDays" [value]="day.value">{{
                      day.label
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <!-- Monthly → First/Last/Custom -->
              <ng-container *ngIf="row.eventType === 'MONTHLY'">
                <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                <mat-form-field
                  appearance="outline"
                  class="short_height flex-1 min-w-0 combined-inner"
                  [ngClass]="{ 'field-error': hasError(i, 'eventSubValue') }"
                >
                  <mat-select
                    [(ngModel)]="row.eventSubValue"
                    [disabled]="isDisabled"
                    (ngModelChange)="emitRows()"
                  >
                    <mat-option *ngFor="let option of monthlyOptions" [value]="option.value">{{
                      option.label
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-container *ngIf="row.eventSubValue === 'CUSTOM'">
                  <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-[70px] shrink-0 combined-inner"
                    [ngClass]="{ 'field-error': hasError(i, 'monthlyCustomDay') }"
                  >
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="31"
                      placeholder="1–31"
                      [(ngModel)]="row.monthlyCustomDay"
                      [disabled]="isDisabled"
                      (blur)="updateErrors()"
                    />
                  </mat-form-field>
                </ng-container>
              </ng-container>

              <!-- Annually → month (all 12) -->
              <ng-container *ngIf="row.eventType === 'ANNUALLY'">
                <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                <mat-form-field
                  appearance="outline"
                  class="short_height flex-1 min-w-0 combined-inner"
                  [ngClass]="{ 'field-error': hasError(i, 'eventSubValue') }"
                >
                  <mat-select
                    [(ngModel)]="row.eventSubValue"
                    [disabled]="isDisabled"
                    (ngModelChange)="emitRows()"
                  >
                    <mat-option *ngFor="let month of months" [value]="month.value">{{
                      month.label
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <!-- Quarterly → Q1 selects start month; Q2/Q3/Q4 auto-derived -->
              <ng-container *ngIf="row.eventType === 'QUARTERLY'">
                <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                <div class="schedule-segments flex-1 flex items-stretch min-w-0">
                  <div class="w-[65px] shrink-0 relative flex items-center px-[6px] min-w-0">
                    <mat-label
                      class="absolute -top-[7px] left-[6px] bg-[#F2F2F2] px-[2px] leading-none"
                      >Q1</mat-label
                    >
                    <mat-form-field
                      appearance="outline"
                      class="short_height w-full combined-inner"
                      [ngClass]="{ 'field-error': hasError(i, 'q1Month') }"
                    >
                      <mat-select
                        [(ngModel)]="row.q1Month"
                        [disabled]="isDisabled"
                        (ngModelChange)="onQ1MonthChange(row)"
                      >
                        <mat-option *ngFor="let month of q1Months" [value]="month.value">{{
                          month.label
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                  <div
                    class="flex-1 relative flex items-center justify-center px-[4px] bg-[#F2F2F2]"
                  >
                    <mat-label
                      class="absolute -top-[7px] left-[4px] bg-[#F2F2F2] px-[2px] leading-none"
                      >Q2</mat-label
                    >
                    <span class="text-[10px] text-gray-500">{{
                      getMonthShortLabel(row.q2Month) || "—"
                    }}</span>
                  </div>
                  <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                  <div
                    class="flex-1 relative flex items-center justify-center px-[4px] bg-[#F2F2F2]"
                  >
                    <mat-label
                      class="absolute -top-[7px] left-[4px] bg-[#F2F2F2] px-[2px] leading-none"
                      >Q3</mat-label
                    >
                    <span class="text-[10px] text-gray-500">{{
                      getMonthShortLabel(row.q3Month) || "—"
                    }}</span>
                  </div>
                  <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                  <div
                    class="schedule-terminal-field flex-1 relative flex items-center justify-center px-[4px] bg-[#F2F2F2]"
                  >
                    <mat-label
                      class="absolute -top-[7px] left-[4px] bg-[#F2F2F2] px-[2px] leading-none"
                      >Q4</mat-label
                    >
                    <span class="text-[10px] text-gray-500">{{
                      getMonthShortLabel(row.q4Month) || "—"
                    }}</span>
                  </div>
                </div>
              </ng-container>

              <!-- Semi-Annually → H1 selects start month; H2 auto-derived -->
              <ng-container *ngIf="row.eventType === 'SEMI_ANNUALLY'">
                <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                <div class="schedule-segments flex-1 flex items-stretch min-w-0">
                  <div class="flex-1 relative flex items-center px-[6px] min-w-0">
                    <mat-label
                      class="absolute -top-[7px] left-[6px] bg-[#F2F2F2] px-[2px] leading-none"
                      >H1</mat-label
                    >
                    <mat-form-field
                      appearance="outline"
                      class="short_height w-full combined-inner"
                      [ngClass]="{ 'field-error': hasError(i, 'h1Month') }"
                    >
                      <mat-select
                        [(ngModel)]="row.h1Month"
                        [disabled]="isDisabled"
                        (ngModelChange)="onH1MonthChange(row)"
                      >
                        <mat-option *ngFor="let month of h1Months" [value]="month.value">{{
                          month.label
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="w-[1px] self-stretch bg-[#D5D5D5]"></div>
                  <div
                    class="schedule-terminal-field flex-1 relative flex items-center justify-center px-[4px] bg-[#F2F2F2]"
                  >
                    <mat-label
                      class="absolute -top-[7px] left-[4px] bg-[#F2F2F2] px-[2px] leading-none"
                      >H2</mat-label
                    >
                    <span class="text-[10px] text-gray-500">{{
                      getMonthShortLabel(row.h2Month) || "—"
                    }}</span>
                  </div>
                </div>
              </ng-container>
            </div>
            <small
              *ngIf="row | feeEventScheduleChanged: oldRows[i]"
              class="flex justify-end px-2 opacity-80"
            >
              {{ oldRows[i] | feeOldEventLabel: cachedEventTypes }}
              <ng-container *ngIf="oldRows[i] | feeOldSubValueLabel: allSubValueOptions">
                &nbsp;— {{ oldRows[i] | feeOldSubValueLabel: allSubValueOptions }}
              </ng-container>
            </small>
          </div>

          <!-- Delete -->
          <button
            [disabled]="isDisabled"
            (click)="removeRow(i)"
            class="delete-btn cursor-pointer bg-white border-[1px] border-[#CC2C2C] rounded-[5px] py-[5px] px-[7px] w-[30px] ml-[20px]"
          >
            <img
              [src]="
                figmaLayout
                  ? 'assets/icons/deposit-product/trash.svg'
                  : 'assets/icons/delete-bin.svg'
              "
              alt="delete-btn"
              class="delete-btn-icon"
            />
          </button>
        </div>
      </div>
    </div>

    <p
      *ngIf="rows.length === 0"
      class="text-center italic text-gray-400 text-sm py-[10px]"
      i18n="@@no_fees_charges_configured"
    >
      No fees/charges configured. Click "+ Add Fee/Charge" to add one.
    </p>
  </div>
</div>
